export default __webpack_public_path__ + "static/media/img--interiors-8.b8415df7.jpg";